import { ReactElement, useEffect, Suspense } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { useRecoilValue } from 'recoil'
import { accessRolesState } from '../../states/access-roles-state'
import AccessRoleForm from '../../forms/access-role-form'
import { useFetchAccessRoles } from '../../hooks/use-fetch-access-roles'
import { ACLContainer } from '../../components/acl-container/acl-container'

const AccessRolesScreen = (): ReactElement => {
  const roles = useRecoilValue(accessRolesState)

  const fetchRoles = useFetchAccessRoles()

  useEffect(() => {
    fetchRoles().catch(() => {
      console.log('error')
    })
  }, [])

  return (
    <Flexbox flex={1} isCol>
      <ScreenTitle title={'Access Roles'} />
      <table className="table table-compact w-full">
        <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Codename</th>
          </tr>
        </thead>
        <tbody>
          {roles.map((item) => {
            return (
              <tr>
                <th>{item.id}</th>
                <td>{item.name}</td>
                <td>{item.codename}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {roles.length === 0 && (
        <Flexbox className="p-4">
          No roles yet. Welcome to <strong>1101 Capital</strong>
        </Flexbox>
      )}
      <ACLContainer onlyAdmin>
        <Suspense>
          <h2 className="text-2xl font-bold uppercase pb-4 pt-8">Add Access Role</h2>
          <AccessRoleForm />
        </Suspense>
      </ACLContainer>
    </Flexbox>
  )
}

export default AccessRolesScreen